"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { Children, type ReactNode } from "react";
import DropCurationButton from "../DropCurationButton";
import WaveDropReactions from "../WaveDropReactions";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly voteAction?: ReactNode;
  readonly showInteractions?: boolean | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
  readonly isVotingControlsLocked?: boolean | undefined;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(37);
  const {
    drop,
    voteAction,
    showInteractions: t1,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t2,
    isVotingControlsLocked: t3
  } = t0;
  const showInteractions = t1 === undefined ? true : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isVotingControlsLocked = t3 === undefined ? false : t3;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const isVotingActionLocked = isVotingClosed || isVotingControlsLocked;
  const canShowVoting = canShowVote && !isVotingActionLocked;
  const canShowCuration = drop.context_profile_context?.curatable ?? false;
  const hasRatings = drop.raters_count > 0;
  const hasWinningThreshold = typeof winningThreshold === "number" && winningThreshold > 0;
  const shouldShowRatings = hasRatings || hasWinningThreshold;
  const hasReactions = drop.reactions.length > 0;
  let t4;
  if ($[0] !== voteAction) {
    t4 = Children.toArray(voteAction);
    $[0] = voteAction;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const normalizedVoteAction = t4;
  const hasVoteAction = normalizedVoteAction.length > 0;
  const hasPrimaryActions = canShowCuration || hasVoteAction;
  const primaryActionsJustificationClass = hasWinningThreshold ? "tw-justify-end" : "tw-justify-center";
  const shouldShowVoteFooter = canShowVoting && (shouldShowRatings || hasPrimaryActions);
  const shouldShowRatingsOnlyFooter = !canShowVoting && shouldShowRatings;
  const shouldShowReactionsFooter = hasReactions || !canShowVoting && canShowCuration;
  const shouldShowReactionsBeforeVoteFooter = hasWinningThreshold && shouldShowVoteFooter && shouldShowReactionsFooter;
  if (!showInteractions) {
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-pb-4" />;
      $[2] = t5;
    } else {
      t5 = $[2];
    }
    return t5;
  }
  let t5;
  if ($[3] !== drop || $[4] !== shouldShowReactionsBeforeVoteFooter) {
    t5 = shouldShowReactionsBeforeVoteFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4 tw-pb-4"><WaveDropReactions drop={drop} /></div>;
    $[3] = drop;
    $[4] = shouldShowReactionsBeforeVoteFooter;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== canShowCuration || $[7] !== drop || $[8] !== hasPrimaryActions || $[9] !== isVotingClosed || $[10] !== normalizedVoteAction || $[11] !== primaryActionsJustificationClass || $[12] !== shouldShowRatings || $[13] !== shouldShowVoteFooter || $[14] !== winningThreshold || $[15] !== winningThresholdMinDurationMs) {
    t6 = shouldShowVoteFooter && <div className="tw-mt-4 tw-@container sm:tw-ml-[3.25rem]" onClick={_temp}><div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-justify-between">{shouldShowRatings && <div className="tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} /></div>}{hasPrimaryActions && <div className={`tw-flex tw-w-full tw-items-center ${primaryActionsJustificationClass} tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-px-6 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-justify-center @[700px]:tw-border-none @[700px]:tw-px-4 @[700px]:tw-pt-0`}><DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />{normalizedVoteAction}</div>}</div></div>;
    $[6] = canShowCuration;
    $[7] = drop;
    $[8] = hasPrimaryActions;
    $[9] = isVotingClosed;
    $[10] = normalizedVoteAction;
    $[11] = primaryActionsJustificationClass;
    $[12] = shouldShowRatings;
    $[13] = shouldShowVoteFooter;
    $[14] = winningThreshold;
    $[15] = winningThresholdMinDurationMs;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== drop || $[18] !== isVotingClosed || $[19] !== shouldShowRatingsOnlyFooter || $[20] !== winningThreshold || $[21] !== winningThresholdMinDurationMs) {
    t7 = shouldShowRatingsOnlyFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} /></div>;
    $[17] = drop;
    $[18] = isVotingClosed;
    $[19] = shouldShowRatingsOnlyFooter;
    $[20] = winningThreshold;
    $[21] = winningThresholdMinDurationMs;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== canShowCuration || $[24] !== canShowVoting || $[25] !== drop || $[26] !== shouldShowReactionsBeforeVoteFooter || $[27] !== shouldShowReactionsFooter) {
    t8 = shouldShowReactionsFooter && !shouldShowReactionsBeforeVoteFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4 tw-pb-4">{!canShowVoting && <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />}<WaveDropReactions drop={drop} /></div>;
    $[23] = canShowCuration;
    $[24] = canShowVoting;
    $[25] = drop;
    $[26] = shouldShowReactionsBeforeVoteFooter;
    $[27] = shouldShowReactionsFooter;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== shouldShowReactionsFooter) {
    t9 = !shouldShowReactionsFooter && <div className="tw-pb-4" />;
    $[29] = shouldShowReactionsFooter;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== t5 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t10 = <>{t5}{t6}{t7}{t8}{t9}</>;
    $[31] = t5;
    $[32] = t6;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
}
function _temp(e) {
  return e.stopPropagation();
}